// Password rules for the first-login change. Aimed at volunteers typing on a
// phone: simple to state, hard to get wrong, and they block the choices that
// actually get church accounts guessed.

const COMMON = new Set([
  'password', 'password1', 'password123', 'passw0rd', '12345678', '123456789',
  '1234567890', 'qwertyui', 'qwerty123', 'iloveyou', 'welcome1', 'welcome123',
  'church123', 'churchaccounts', 'letmein1', 'admin123', 'abc12345',
])

export const PASSWORD_HELP = 'At least 8 characters, with at least one letter and one number.'

/** A plain-language problem with the password, or null if it is acceptable. */
export function passwordProblem(
  password: string,
  who: { email?: string; fullName?: string } = {},
): string | null {
  if (password.length < 8) return 'Use at least 8 characters.'
  if (password.length > 72) return 'That is too long. Use 72 characters or fewer.'
  if (!/[A-Za-z]/.test(password)) return 'Add at least one letter.'
  if (!/[0-9]/.test(password)) return 'Add at least one number.'
  const lower = password.toLowerCase()
  if (COMMON.has(lower)) return 'That password is too easy to guess. Choose another.'
  const local = (who.email ?? '').split('@')[0]?.toLowerCase() ?? ''
  if (local.length >= 4 && lower.includes(local)) return 'Do not use your email address in your password.'
  const first = (who.fullName ?? '').trim().split(/\s+/)[0]?.toLowerCase() ?? ''
  if (first.length >= 4 && lower === first) return 'Do not use just your name.'
  return null
}
